import { Trans, useTranslation } from 'react-i18next';
import { RESERVABLE_TIME_UNIT_IN_MINUTES, SPACE_TYPE } from '@/constants/space';

/**
 * 時間選択ページの注意事項セクションコンポーネント
 */
export const TimeSelectionNotice = () => {
  const { t } = useTranslation();

  return (
    <div className="f2__notice">
      <div className="f2__notice-left">
        <h3 className="f2__notice-heading">
          <img
            className="f2__notice-heading-icon"
            src="/Common_Icon_Attention.png"
            alt={t('common.altText.attention')}
          />
          <span className="f2__notice-heading-text">
            {t('shareDevice.timeSelection.notice.title')}
          </span>
        </h3>
        <ul className="f2__notice-list">
          <li className="f2__notice-item">
            <Trans
              i18nKey="shareDevice.timeSelection.notice.noExtension"
              components={{ br: <br /> }}
            />
          </li>
          <li className="f2__notice-item">
            {t('shareDevice.timeSelection.notice.autoCancellation')}
          </li>
        </ul>
      </div>
      <div className="f2__notice-right">
        <div className="f2__notice-callout">
          <div className="f2__notice-callout-inner">
            <img
              className="f2__notice-callout-icon"
              src="/Common_Icon_Attention.png"
              alt={t('common.altText.attention')}
            />
            <Trans
              i18nKey="shareDevice.timeSelection.notice.usageTime"
              components={{ br: <br /> }}
            />
            <br />
            <span className="f2__notice-callout-big">
              {RESERVABLE_TIME_UNIT_IN_MINUTES[SPACE_TYPE.SHOWER_ROOM]}
            </span>{' '}
            <span className="f2__notice-callout-color">
              <Trans
                i18nKey="shareDevice.timeSelection.notice.usageTimeMinutes"
                components={{ br: <br /> }}
              />
            </span>
            {t('shareDevice.timeSelection.notice.usageTimeStart')}
          </div>
        </div>
      </div>
    </div>
  );
};
